var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cabinet-schedule"},_vm._l((_vm.items),function(item,index){return _c('div',{key:`${item.month}-${index}`,staticClass:"cabinet-schedule__row"},[_c('span',[_vm._v(_vm._s(item.month))]),_c('cabinet-status',{attrs:{"status":item.status}}),_c('strong',[_vm._v(_vm._s(item.amount))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }